import { queryNameService, relocateService } from '@http/profileService'
import { selectCredentials } from '@views/loginView/state/loginSlice'
import { call, takeEvery, put, select } from 'redux-saga/effects'
import {
  queryByName,
  queryByName2,
  queryByNameFailed,
  queryByNameFailed2,
  queryByNameSuccess,
  queryByNameSuccess2,
  relocateAction,
  relocateUser,
  relocateUserFailed,
  relocateUserSuccess
} from './manageSlice'
import { PayloadAction } from '@reduxjs/toolkit'

export function* callQueryName({ payload }: PayloadAction<string>) {
  const { cocap } = yield select(selectCredentials)
  try {
    const result = yield call(queryNameService, payload, cocap)
    yield put(queryByNameSuccess(result))
  } catch (e) {
    yield put(queryByNameFailed(e.message))
  }
}

export function* callQueryName2({ payload }: PayloadAction<string>) {
  const { cocap } = yield select(selectCredentials)
  try {
    const result = yield call(queryNameService, payload, cocap)
    yield put(queryByNameSuccess2(result))
  } catch (e) {
    yield put(queryByNameFailed2(e.message))
  }
}

export function* relocateUserSaga({ payload }: relocateAction) {
  const { cocap } = yield select(selectCredentials)
  const { newParentId, user } = payload
  try {
    if (!newParentId || !user._id || !user.parent?._id) throw new Error('Empty user ids param')
    yield call(
      relocateService,
      payload.newParentId || '',
      payload.user.parent?._id || '',
      payload.user?._id || '',
      cocap
    )
    yield put(relocateUserSuccess())
  } catch (e) {
    yield put(relocateUserFailed(e.message))
  }
}

export default function* manageSaga() {
  yield takeEvery(queryByName.type, callQueryName)
  yield takeEvery(queryByName2.type, callQueryName2)
  yield takeEvery(relocateUser.type, relocateUserSaga)
}
